import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasosNavComponent } from '../../../componentes/formularios/pasos-nav/pasos-nav.component';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { MapaUnicoPuntoComponent } from '../../../auxiliares/mapa-unico-punto/mapa-unico-punto.component';
import { VehiculosRoutingModule } from './routing';
import { MapaFacilComponent } from '../../../auxiliares/mapa-facil/mapa-facil.component';
import { DateRangeSelectorComponent } from '../../../auxiliares/date-range-selector/date-range-selector.component';
import { MapDrawMapboxComponent } from '../../../auxiliares/map-draw-mapbox/map-draw-mapbox.component';
import { ListadoConfigsEventosComponent } from '../../standalone/configs-eventos/listado-configs-eventos/listado-configs-eventos.component';
import { ListadoNotasComponent } from '../../standalone/notas/listado-notas/listado-notas.component';
import { ListadoConfigEventoUsuarioComponent } from '../../standalone/config-evento-usuario/listado-config-evento-usuario/listado-config-evento-usuario.component';
import { ListadoCertificadoEntidadComponent } from '../../standalone/certificado-entidad/listado-certificado-entidad/listado-certificado-entidad.component';
import { ListadoVehiculosComponent } from './vehiculos/listado-vehiculos/listado-vehiculos.component';
import { DetallesVehiculoComponent } from './vehiculos/detalles-vehiculo/detalles-vehiculo.component';
import { DetallesVehiculoInfoComponent } from './vehiculos/detalles-vehiculo-info/detalles-vehiculo-info.component';
import { CrearEditarVehiculoComponent } from './crear-editar-vehiculo/crear-editar-vehiculo.component';
import { ListadoDocumentosComponent } from '../../standalone/documentos/listado-documentos/listado-documentos.component';
import { ListadoEnviosVehiculosComponent } from './envios-movil/listado/listado.component';
import { JerarquiaClienteComponent } from '../../standalone/jerarquia-cliente/jerarquia-cliente.component';
import { FiltroComponent } from '../../../auxiliares/tabla/filtro/filtro.component';
import { ButtonComponent } from '../../../auxiliares/button/button.component';
import { CardComponent } from '../../../auxiliares/cards/cards.component';
import { DarAltaVehiculoComponent } from './dar-alta-vehiculo/dar-alta-vehiculo.component';
import { DashboardVehiculosComponent } from './dashboard/dashboard-vehiculos.component';
import { UploadFileComponent } from '../../../auxiliares/upload-file/upload-file.component';
import { ListadoComandosComponent } from './vehiculos/listado-comandos/listado-comandos.component';
import { ListadoViajesComponent } from './vehiculos/listado-viajes/listado-viajes.component';
import { ListadoCumplimientosRecorridoComponent } from './vehiculos/listado-cumplimientos-recorrido/listado-cumplimientos-recorrido.component';
import { SincronizarSoflexComponent } from './vehiculos/sincronizar-soflex/sincronizar-soflex.component';
import { SelectorTipoMapaComponent } from '../../standalone/selector-tipo-mapa/selector-tipo-mapa.component';
import { MostrarServiciosComponent } from '../../../auxiliares/mostrar-servicios/mostrar-servicios.component';
import { MapaIndividualVehiculosComponent } from './contenedor-mapa/mapas-individuales/mapa-individual.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { BarraLateralComponent } from './contenedor-mapa/barra-lateral/barra-lateral.component';
import { ContenedorMapaComponent } from './contenedor-mapa/contenedor-mapa.component';
import { InfoVehiculoComponent } from './contenedor-mapa/barra-lateral/detalles/info-vehiculo/info-vehiculo.component';
import { AsignarRecorridoDialogComponent } from './contenedor-mapa/barra-lateral/detalles/info-vehiculo/asignar-recorrido-dialog/asignar-recorrido-dialog.component';
import { InfoReporteComponent } from './contenedor-mapa/barra-lateral/detalles/info-reporte/info-reporte.component';
import { BusquedaZonaComponent } from './contenedor-mapa/barra-lateral/busqueda-especifica/busqueda-zona/busqueda-zona.component';
import { BusquedaZonaService } from './contenedor-mapa/barra-lateral/busqueda-especifica/busqueda-zona/busqueda-zona.service';
import { BusquedaVehiculoRecorridosComponent } from './contenedor-mapa/barra-lateral/busqueda-especifica/recorridos/recorridos.component';
import { ListaParadasComponent } from './contenedor-mapa/barra-lateral/busqueda-especifica/listas/lista-paradas/lista-paradas.component';
import { ListaEventosComponent } from './contenedor-mapa/barra-lateral/busqueda-especifica/listas/lista-eventos/lista-eventos.component';
import { ListaExcesosComponent } from './contenedor-mapa/barra-lateral/busqueda-especifica/listas/lista-excesos/lista-excesos.component';
import { ListaCategoriaComponent } from './contenedor-mapa/barra-lateral/busqueda-especifica/listas/lista-categoria/lista-categoria.component';
import { FiltrosVehiculoComponent } from './contenedor-mapa/barra-lateral/filtros/filtros-vehiculos.component';
import { ListadoReportesGenericosComponent } from '../../standalone/listado-reportes-genericos/listado-reportes-genericos.component';
import { ListadoRecorridosVehiculosComponent } from './recorridos/listado-recorridos/listado-recorridos.component';
import { CrearEditarRecorridoVehiculosComponent } from './recorridos/crear-editar-recorrido/crear-editar-recorrido.component';
import { PlanificadorRutaVehiculosComponent } from './recorridos/planificador-ruta/planificador-ruta.component';
import { DetalleCumplimientoPuntosComponent } from './recorridos/detalle-cumplimiento-puntos/detalle-cumplimiento-puntos.component';
import { ListadoRecorridosDinamicosVehiculosComponent } from './recorridos-dinamicos/listado-recorridos-dinamicos/listado-recorridos-dinamicos.component';
import { HistorialRecorridosDinamicosComponent } from './vehiculos/historial-recorridos-dinamicos/historial-recorridos-dinamicos.component';
import { MapaUbicarComponent } from '../../../auxiliares/mapas/mapa-ubicar/mapa-ubicar.component';
import { EventosGenericosModule } from '../eventos-genericos/module';
import { AdministracionModule } from '../administracion/module';
import { MapCardComponent } from '../../../componentes/map-card/map-card.component';
import { HintComponent } from '../../../componentes/hint/hint.component';
import { ListadoAsignacionsComponent } from '../../standalone/asignacions/listado-asignacions/listado-asignacions.component';
import { ConfigHorariosAtencionComponent } from '../../standalone/config-horarios-atencion/config-horarios-atencion.component';
import { ClienteSelectorComponent } from '../../../componentes/selectores/cliente-selector/cliente-selector.component';
import { ListadoReportesCombustibleComponent } from '../../../componentes/listado-reportes-combustible/listado-reportes-combustible.component';
import { ListadoReportesTemperaturaComponent } from '../../../componentes/listado-reportes-temperatura/listado-reportes-temperatura.component';
import { DatePickerComponent } from '../../../componentes/date-picker/date-picker.component';
import { InformeCombustibleComponent } from './dashboard/informe-combustible/informe-combustible.component';
import { HistorialVehiculoComponent } from '../../standalone/historial-vehiculo/historial-vehiculo.component';
import { ListadoServiciosComponent } from '../../standalone/servicios/listado-servicios/listado-servicios.component';
import { ListadoRecordatoriosComponent } from '../../standalone/recordatorios/listado-recordatorios/listado-recordatorios.component';
import { HorizontalScrollerComponent } from '../../../componentes/horizontal-scroller/horizontal-scroller.component';
import { DashboardPanelComponent } from '../../../componentes/dashboard-panel/dashboard-panel.component';
import { DashboardFiltrosComponent } from '../../../componentes/dashboard-filtros/dashboard-filtros.component';
import { PIEZAS_DETALLE } from '../../../componentes/detalle/detalle.components';

@NgModule({
  declarations: [
    //Vehículos
    ListadoVehiculosComponent,
    CrearEditarVehiculoComponent,
    DetallesVehiculoComponent,
    DetallesVehiculoInfoComponent,
    ListadoComandosComponent,
    ListadoViajesComponent,
    ListadoCumplimientosRecorridoComponent,
    HistorialRecorridosDinamicosComponent,
    SincronizarSoflexComponent,

    //Mapas Vehiculos
    ContenedorMapaComponent,
    MapaIndividualVehiculosComponent,

    //Barra lateral
    BarraLateralComponent,
    //A-Detalles
    InfoVehiculoComponent,
    AsignarRecorridoDialogComponent,
    InfoReporteComponent,
    //B-Búsqueda específica
    BusquedaZonaComponent,
    BusquedaVehiculoRecorridosComponent,
    ListaParadasComponent,
    ListaEventosComponent,
    ListaExcesosComponent,
    //C-Filtros
    FiltrosVehiculoComponent,

    //Otros
    DarAltaVehiculoComponent,
    DashboardVehiculosComponent,
    ListadoEnviosVehiculosComponent,

    //Recorridos
    ListadoRecorridosVehiculosComponent,
    CrearEditarRecorridoVehiculosComponent,
    PlanificadorRutaVehiculosComponent,
    DetalleCumplimientoPuntosComponent,
    ListadoRecorridosDinamicosVehiculosComponent,
  ],
  imports: [
    ...PIEZAS_DETALLE,
    CommonModule,
    AuxiliaresModule,
    PasosNavComponent,
    DashboardPanelComponent,
    DashboardFiltrosComponent,
    DragDropModule,
    VehiculosRoutingModule,
    MapaUnicoPuntoComponent,
    MapaFacilComponent,
    DateRangeSelectorComponent,
    MapDrawMapboxComponent,
    ListadoNotasComponent,
    ListadoConfigsEventosComponent,
    ListadoConfigEventoUsuarioComponent,
    ListadoCertificadoEntidadComponent,
    ListadoDocumentosComponent,
    JerarquiaClienteComponent,
    FiltroComponent,
    ButtonComponent,
    CardComponent,
    UploadFileComponent,
    SelectorTipoMapaComponent,
    ListadoReportesGenericosComponent,
    MapaUbicarComponent,
    MostrarServiciosComponent,
    EventosGenericosModule,
    AdministracionModule,
    MapCardComponent,
    HintComponent,
    ListadoAsignacionsComponent,
    ConfigHorariosAtencionComponent,
    ClienteSelectorComponent,
    ListadoReportesCombustibleComponent,
    ListadoReportesTemperaturaComponent,
    DatePickerComponent,
    InformeCombustibleComponent,
    HistorialVehiculoComponent,
    ListadoServiciosComponent,
    ListadoRecordatoriosComponent,
    HorizontalScrollerComponent,
    ListaCategoriaComponent,
  ],
  providers: [BusquedaZonaService],
})
export class VehiculosModule {}
